export function Defs() {
  return (
    <defs>
      <linearGradient id="lineGradient" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0%" stopColor="#a8e6cf" />
        <stop offset="50%" stopColor="#7ebcbeff" />
        <stop offset="100%" stopColor="#6fc0f0ff" />
      </linearGradient>

      <linearGradient id="areaGradient" x1="0" y1="0" x2="0" y2="1">
        <stop offset="100%" stopColor="rgba(100, 149, 237, 0.4)" />
        <stop offset="0" stopColor="rgba(100, 149, 237, 1)" />
      </linearGradient>
    </defs>
  );
}
